module.exports = __webpack_public_path__ + "img/green-sweater.35447990.webp";